import React, { useState } from 'react';
import { Popover } from 'antd';
import { Button } from 'ui';
import { useIntl } from 'react-intl';
import { TooltipPlacement } from 'antd/es/tooltip';

interface FilterPopoverInterface {
    handleOpen: Function;
    content: any;
    loading?: boolean;
    title: string;
    buttonTitle: string;
    className?: string;
    placement?: TooltipPlacement;
    setOpen: React.Dispatch<React.SetStateAction<string>>;
    popoverKey: string;
    filterKey: string;
}

// Popover arrow offset + title row + inner paddings + breathing room.
const POPOVER_CHROME = 80;
const MIN_CONTENT_HEIGHT = 150;

const FilterPopover: React.FC<FilterPopoverInterface> = ({
    popoverKey,
    filterKey,
    setOpen,
    handleOpen,
    content,
    className,
    loading = false,
    title,
    buttonTitle,
    placement = 'bottom',
}) => {
    const intl = useIntl();
    const [maxHeight, setMaxHeight] = useState<number>();

    // The popover is rendered into <body>; taller than the free space it stretches the page past the fixed footer.
    // antd only flips bottom/top, never shrinks, so cap the content to the room below the button.
    const measure = (trigger: HTMLElement) => {
        const footer = document.querySelector('.page-footer');
        const limit = footer ? footer.getBoundingClientRect().top : window.innerHeight;
        const free = limit - trigger.getBoundingClientRect().bottom - POPOVER_CHROME;
        setMaxHeight(Math.max(free, MIN_CONTENT_HEIGHT));
    };

    return (
        <Popover
            open={popoverKey === filterKey}
            onOpenChange={(open: boolean) => handleOpen(open)}
            placement={placement}
            overlayClassName={className}
            title={intl.formatMessage({ id: title })}
            content={<div className={'filter-popover-content'} style={{ maxHeight }}>{content}</div>}
            trigger="click"
        >
            <Button
                onClick={(e: React.MouseEvent<HTMLElement>) => {
                    measure(e.currentTarget);
                    setOpen(filterKey === popoverKey ? '' : popoverKey);
                }}
                loading={loading}
                className={'mx-1 mb-1'}
                type={'outline'}
                icon='fa-sharp fa-regular fa-plus'
                message={buttonTitle}
            />
        </Popover>
    );
};

export default FilterPopover;
